const clientConfig = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "2oxqgrzi",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
};

export default clientConfig;
